<template>
    <div class="table-tools-actions flex justify-center md:justify-end w-full items-center space-x-2 select-none pr-4">
      <base-button @click="toggleSearchesDialog" size="xs" class="w-full md:w-auto" text="Columnas"></base-button>
    </div>
</template>

<script>
export default {
  name: 'base-table-searches',
  data: function () {
    return {
      search: ''
    }
  },
  methods: {
    toggleSearchesDialog: function () {
      this.$emit('toggleColumnasMetadatosDialog')
    },
  }
}
</script>

